/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".color-picker-toggle{display:block;height:34px;border:1px solid #a9a9a9;width:100%}.color-picker{width:200px;z-index:10003;position:relative}.color-picker .label{position:absolute;right:-15px;top:-15px;cursor:pointer;z-index:2}.color-picker .label:before{padding-right:0}"];
export { styles as styles };
